export default __webpack_public_path__ + "static/media/IMG_0014_5_11zon.8e118aaa.jpg";